import { render, staticRenderFns } from "./TasweqProfile.vue?vue&type=template&id=9ffe0602&scoped=true"
import script from "./TasweqProfile.vue?vue&type=script&lang=js"
export * from "./TasweqProfile.vue?vue&type=script&lang=js"
import style0 from "./TasweqProfile.vue?vue&type=style&index=0&id=9ffe0602&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ffe0602",
  null
  
)

export default component.exports